
import Popover from 'vux/src/components/popover/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import Popup from 'vux/src/components/popup/index.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'

export default {
name: 'VyHeader',
components: {
Popover,
XButton,
Popup,
},
directives: {
TransferDom,
},
props: {
headerTitle: {
type: String,
required: false,
default: '',
},
preventBack: {
type: Boolean,
required: false,
default: false,
},
hasView: {
type: Boolean,
required: false,
default: false,
},
viewFilterItems: {
type: Array,
required: false,
default () {
return []
},
},
rightOption: {
type: Object,
default () {
return {
hasDelete: false,
hasNew: false,
hasFilter: false,
}
},
},
},
data () {
return {
viewFilterShow: false,
}
},
watch: {

viewFilterShow (val, oldVal) {

var popupMask = document.getElementsByClassName('vux-popup-mask')
if(val === false) {
popupMask[0].style.setProperty('top', '0', 'important')
popupMask[0].style.setProperty('transition', 'opacity 0ms', 'important')
}
},
},
methods: {
clickFilter () {
this.$emit('on-filter-click')
},
getStyle (obj, attr) {
if(obj.currentStyle) {
return obj.currentStyle[attr]
} else {
return document.defaultView.getComputedStyle(obj, null)[attr]
}
},
viewFilterShowIf () {
let elementDialog = document.getElementsByClassName('sortAside_ignore')
let elementMask = document.getElementsByClassName('vux-popup-mask')
if(elementDialog.length > 0) {
elementDialog[0].style.setProperty('display', 'none', 'important')
}
this.viewFilterShow = !this.viewFilterShow
if(!this.viewFilterShow) {
elementMask[0].style.setProperty('z-index', '-1', 'important')
}

let elementDomHeight = 8 * this.viewFilterItems.length
let elementDom = document.getElementsByClassName('viewFilterAside_ignore')

if(this.viewFilterShow) {
this.asideFilterShow = false
this.showSortOptions = false
}

var popupMask = document.getElementsByClassName('vux-popup-mask')
















var popupMaskHeight = '46px'
popupMask[0].style.setProperty('top', popupMaskHeight, 'important')
for(let i = 0; i < elementDom.length; i++) {
elementDom[i].style.setProperty(
'height',
elementDomHeight + 'vh',
'important'
)
elementDom[i].style.setProperty(
'transition-duration',
'0ms',
'important'
)
elementDom[i].style.setProperty('bottom', 'auto', 'important')
elementDom[i].style.setProperty('top', popupMaskHeight, 'important')
}
},
handleGoBack () {
if(!this.preventBack) {
console.log('中转', this.$route.query.view)
if(
this.$route.query.view === 1 ||
this.$route.query.view === undefined
) {

console.log('路由回退***********')
this.$router.push({
name: 'Entry',
})
} else {
console.log('中转', this.$route.query.tab)
console.log('中转', this.$route.query.keys)
console.log('路由回退***********')
this.$router.push({
name: 'Todo_list',
query: {
tab: this.$route.query.tab,
keys: this.$route.query.keys,
view: 2,
},
})
}
} else {
this.$emit('on-goback-click')
}
},
handleNew () {
this.$emit('on-newcreate-click')
},
handleDel () {
this.$emit('on-delete-click')
},
moreButtonClick (btnKey) {
if(btnKey !== 'uploadAttachment') {
this.$emit('on-moreButton-click', btnKey)
}
},
newMoreButtonClick (btnKey) {
this.$emit('on-newMoreButton-click', btnKey)
},
handleMore () {
this.$emit('on-more-click')
},
viewFilterConfirm (viewFilterItem) {
for(let i = 0, len = this.viewFilterItems.length; i < len; i++) {
if(this.viewFilterItems[i].itemKey === viewFilterItem.itemKey) {
this.viewFilterItems[i].choosed = true
} else {
this.viewFilterItems[i].choosed = false
}
}
this.viewFilterShow = !this.viewFilterShow
this.$emit('on-headerView-click', viewFilterItem)
},

clear (e) {
console.log('click', e)
e.target.value = ''
},

getFile () {
let files = this.$refs.file[0].files
this.$emit('get-files', files)
},
},
}



// WEBPACK FOOTER //
// ./src/components/basic/VyHeaderXX.vue